import './BroadcastStats.sass';

import React, { FC, useCallback, useEffect } from 'react';

import { Loader, MetaTags } from '$shared/components';
import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { imActions, imBroadcastStatsSelector } from '$store/im';
import { useTranslator } from '$hooks';
import { useDispatch, useSelector } from 'react-redux';
import { goTo } from '$navigation/helper';
import { BROADCAST, IM } from '$shared/constants/pages';
import { mainSelector } from '$store/main';
import { BroadcastsItem } from '$core/BroadcastStats/BroadcastsItem/BroadcastsItem';
import { rnbr } from '$utils';

export const BroadcastStats: FC = () => {
  const t = useTranslator();
  const { canBroadcastMessages, mVerified } = useSelector(mainSelector);
  const { isLoading, isLoadingMore, broadcasts, nextFrom } = useSelector(
    imBroadcastStatsSelector,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(imActions.loadBroadcastStats());
  }, [dispatch]);

  if (!canBroadcastMessages || !mVerified) {
    goTo(IM);
    return null;
  }

  const handleCreateBroadcast = useCallback(() => {
    goTo(BROADCAST);
  }, [mVerified]);

  return (
    <>
      <MetaTags title={t('broadcast_stats_title')} />
      <Header showBackButton>{t('broadcast_stats_title')}</Header>
      <ScrollView
        onLoadMore={() => dispatch(imActions.loadMoreBroadcastStats(nextFrom))}
        canLoadMore={!isLoading && !isLoadingMore && !!nextFrom}
        isLoadingMore={isLoadingMore}
      >
        {isLoading ? (
          <Loader isWrapped />
        ) : !broadcasts.length ? (
          <Placeholder
            actions={
              <Button
                onClick={handleCreateBroadcast}
                stretched
                size="small"
                mode="secondary"
              >
                {t('broadcast_stats_empty_placeholder_button')}
              </Button>
            }
            centered
          >
            {rnbr(t('broadcast_stats_empty_placeholder_text'))}
          </Placeholder>
        ) : (
          <div className="BroadcastStats__items">
            {broadcasts.map((broadcast) => (
              <BroadcastsItem key={broadcast.id} broadcast={broadcast} />
            ))}
          </div>
        )}
      </ScrollView>
    </>
  );
};
